<header class="header-wrap">
    <div
        (clickOutside)="onClickOutside()"
        *transloco="let t; currentLang as currentLang"
        appClickOutside
        class="mx-auto max-w-screen-lg"
    >
        <div class="px-4 py-3 lg:px-0">
            <div class="flex flex-row items-center justify-between text-white">
                <!-- Left: Logo + Nav -->
                <div class="flex items-center gap-1 whitespace-nowrap">
                    <a [routerLink]="['/']" class="cursor-pointer">
                        <img
                            alt="Quizzaro"
                            class="h-10 w-auto md:h-12 lg:-ml-4"
                            src="/assets/image/logo.png"
                        />
                    </a>
                    <nav class="hidden items-center md:flex">
                        <!-- Categories dropdown -->
                        <div
                            (mouseleave)="isMenu1Open.set(false)"
                            class="relative inline-block text-left"
                        >
                            <button
                                (mouseenter)="isMenu1Open.set(true)"
                                class="nav-link inline-flex items-center gap-1 px-3 py-2 text-sm font-semibold text-white/90 transition-colors hover:text-white"
                            >
                                {{ t('header.categories') }}
                                <app-dropdown-arrow [isOpen]="isMenu1Open()" class="ml-0.5"></app-dropdown-arrow>
                            </button>
                            @if (isMenu1Open()) {
                                <div class="dropdown-panel absolute left-0 z-50 w-48 pt-1" role="menu">
                                <div class="dropdown-menu overflow-hidden rounded-xl">
                                    <a
                                        [routerLink]="['/quizzes', lang]"
                                        class="dropdown-item block px-4 py-2.5 text-sm"
                                        role="menuitem"
                                    >
                                        {{ t('header.categories.all') }}
                                    </a>
                                    @for (item of categoryLinks; track item) {
                                        <a
                                            [queryParams]="{ category: item.toLowerCase() }"
                                            [routerLink]="['/quizzes', lang]"
                                            class="dropdown-item block px-4 py-2.5 text-sm"
                                            role="menuitem"
                                        >
                                            {{ t('header.categories.' + item) | capitalize }}
                                        </a>
                                    }
                                </div>
                                </div>
                            }
                        </div>

                        <!-- Top Games dropdown -->
                        <div
                            (mouseleave)="isMenu2Open.set(false)"
                            class="relative inline-block text-left"
                        >
                            <button
                                (mouseenter)="isMenu2Open.set(true)"
                                class="nav-link inline-flex items-center gap-1 px-3 py-2 text-sm font-semibold text-white/90 transition-colors hover:text-white"
                            >
                                {{ t('header.topGames') }}
                                <app-dropdown-arrow [isOpen]="isMenu2Open()" class="ml-0.5"></app-dropdown-arrow>
                            </button>
                            @if (isMenu2Open()) {
                                <div class="dropdown-panel absolute left-0 z-50 w-48 pt-1" role="menu">
                                <div class="dropdown-menu overflow-hidden rounded-xl">
                                    @for (item of topGamesLinks; track item) {
                                        <a
                                            (click)="goToFeaturePage(item)"
                                            class="dropdown-item block cursor-pointer px-4 py-2.5 text-sm"
                                            role="menuitem"
                                        >
                                            {{ t('featured.' + item) }}
                                        </a>
                                    }
                                </div>
                                </div>
                            }
                        </div>
                    </nav>
                </div>

                <!-- Right: Actions -->
                <nav class="hidden items-center gap-3 whitespace-nowrap md:flex">
                    <app-currency-selector></app-currency-selector>

                    @defer {
                        @if (!loggedIn()) {
                            <div class="flex gap-2">
                                <a
                                    [routerLink]="['/auth', 'register']"
                                    class="header-btn-light cursor-pointer rounded-lg px-4 py-2 text-sm font-semibold"
                                >
                                    {{ t('auth.getStarted') }}
                                </a>
                                <a
                                    [routerLink]="['/auth', 'login']"
                                    class="header-btn-outline cursor-pointer rounded-lg px-4 py-2 text-sm font-semibold"
                                >
                                    {{ t('auth.login') }}
                                </a>
                            </div>
                        }
                    }

                    <!-- Cart -->
                    <a [routerLink]="['checkouts']" class="relative flex cursor-pointer items-center p-2">
                        <svg class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 100 4 2 2 0 000-4z" />
                        </svg>
                        @if (cartService.cartItems().length) {
                            <span class="cart-badge absolute -right-1 -top-1">
                                {{ cartService.cartItems().length }}
                            </span>
                        }
                    </a>

                    <!-- Logged in section -->
                    @if (loggedIn()) {
                        <div class="relative flex items-center gap-3">
                            <a [routerLink]="['game-center']" class="header-game-btn">
                                <svg class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 3l14 9-14 9V3z" />
                                </svg>
                                {{ t('header.gameCenter') }}
                            </a>

                            <app-profile-avatar
                                (click)="toggleProfileMenu()"
                                class="cursor-pointer"
                            ></app-profile-avatar>

                            @if (isProfileMenuOpen()) {
                                <div class="dropdown-menu absolute right-0 top-12 z-50 w-52 overflow-hidden rounded-xl" role="menu">
                                    <a [routerLink]="['change-profile']" class="dropdown-item flex items-center gap-3 px-4 py-3 text-sm">
                                        <svg class="h-4 w-4 text-secondary-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                        </svg>
                                        {{ t('header.profile') }}
                                    </a>
                                    <a [routerLink]="['change-password']" class="dropdown-item flex items-center gap-3 px-4 py-3 text-sm">
                                        <svg class="h-4 w-4 text-secondary-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                                        </svg>
                                        {{ t('header.changePassword') }}
                                    </a>
                                    <a [routerLink]="['referrals']" class="dropdown-item flex items-center gap-3 px-4 py-3 text-sm">
                                        <svg class="h-4 w-4 text-secondary-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                        {{ t('header.referralLink') }}
                                    </a>
                                    <div class="my-1 border-t border-secondary-100"></div>
                                    <a (click)="authStateService.logout()" class="dropdown-item flex cursor-pointer items-center gap-3 px-4 py-3 text-sm text-accent-600">
                                        <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                        </svg>
                                        {{ t('header.logout') }}
                                    </a>
                                </div>
                            }
                        </div>
                    }
                </nav>

                <!-- Mobile: icons + hamburger -->
                <div class="flex items-center gap-3 md:hidden">
                    @if (loggedIn()) {
                        <a [routerLink]="['game-center']" class="flex items-center gap-1.5 text-sm font-semibold text-white">
                            <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M5 3l14 9-14 9V3z" />
                            </svg>
                        </a>
                    }
                    <a [routerLink]="['checkouts']" class="relative flex cursor-pointer items-center p-1">
                        <svg class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 100 4 2 2 0 000-4z" />
                        </svg>
                        @if (cartService.cartItems().length) {
                            <span class="cart-badge absolute -right-2 -top-2">
                                {{ cartService.cartItems().length }}
                            </span>
                        }
                    </a>
                    <button
                        (click)="toggleNavbar()"
                        class="inline-grid place-content-center rounded-lg p-2 text-white hover:bg-white/10"
                    >
                        <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path
                                [class.block]="!isExpanded()"
                                [class.hidden]="isExpanded()"
                                d="M4 6h16M4 12h16m-7 6h7"
                                stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            ></path>
                            <path
                                [class.block]="isExpanded()"
                                [class.hidden]="!isExpanded()"
                                d="M6 18L18 6M6 6l12 12"
                                stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            ></path>
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <!-- Mobile dropdown -->
        @if (isExpanded()) {
            <div class="relative z-50 block md:hidden">
                <app-header-mobile [lang]="currentLang"
                    class="mobile-dropdown absolute left-0 right-0 top-0 p-4"
                ></app-header-mobile>
            </div>
        }
    </div>
</header>
